import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileBottomBar from "@/components/feature/MobileBottomBar";

export default function UeberUns() {
  return (
    <>
      <Navbar />
      <main className="pt-24 md:pt-28 min-h-screen">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-16 md:py-24">
          <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-start">
            <div className="w-full md:w-[260px] flex-shrink-0">
              <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden bg-background-100">
                <img
                  src="https://storage.helloreaddy.io/project_files/ccd3f37f-a1a3-49ba-8460-6107752c615a/d3f290b3-09e9-469b-9a80-1468a9774dcd_compressed_Portrait-Maike.webp"
                  alt="Mareike Stöhr – Inhaberin von Blumen Stöhr"
                  title="Mareike Stöhr – Inhaberin von Blumen Stöhr"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="mt-4 text-center">
                <p className="font-heading text-lg text-foreground-950">Mareike Stöhr</p>
                <p className="text-sm text-foreground-600">Inhaberin & Floristin</p>
              </div>
            </div>

            <div className="flex-1">
              <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
                Florales Handwerk mit Geschichte
              </h1>
              <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8">
                Seit über 100 Jahren verbinden wir florales Handwerk, persönliche Beratung und kreative Ideen zu einzigartigen Blumenarrangements. Unter der Leitung von Mareike Stöhr führen wir die lange Tradition der Familie mit Leidenschaft und modernem Gestaltungsanspruch fort.
              </p>
              <div className="space-y-4 text-foreground-700">
                <p>Familiengeführtes Unternehmen mit mehr als 100 Jahren Tradition</p>
                <p>Persönliche Leitung durch Mareike Stöhr</p>
                <p>Handwerkliche Erfahrung und kreative, individuelle Gestaltung</p>
                <p>Persönliche und intensive Fachberatung</p>
                <p>Regionale Verbundenheit mit Leer und Ostfriesland</p>
                <p>Täglich wechselnde florale Ideen und Arrangements</p>
                <p>Verbindung von Tradition und aktuellen Floristiktrends</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}